import { ReportDetailsScreen } from "./report-details.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";

export const ReportDetailsRoutes: RouteDefinition[] = [
	{
		path: Paths.reports.withIdPlaceholder().details.path,
		element: <ReportDetailsScreen />,
		requiredPermissions: ["UserInAccountPermission_ReportAdmin_Read"],
	},
];
